export default "__VITE_ASSET__7999dda6__"